import styled, { keyframes } from 'styled-components'

import { Link } from '@reveni-io/reveni-ui'

export { BrandedBackground as Layout } from '@/common/styles'

export const Card = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp40};
  width: 100%;
  max-width: 436px;
  padding: ${props => props.theme.spacing.sp32} ${props => props.theme.spacing.sp48};
  border-radius: ${props => props.theme.radius.modal};
  box-shadow: ${props => props.theme.elevation.elevation3};
  background-color: ${props => props.theme.colors.background.primary};
  overflow: hidden;
`

const scrollIcons = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-478px);
  }
`

export const IconsContainer = styled.div`
  flex-shrink: 0;
  width: 478px;
  height: ${props => props.theme.size.M};
  overflow: hidden;
`

export const IconsTrack = styled.div`
  display: flex;
  height: 100%;
  animation: ${scrollIcons} 7.97s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const IconsStrip = styled.img`
  flex-shrink: 0;
  width: 478px;
  height: ${props => props.theme.size.M};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp24};
  width: 100%;
`

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.spacing.sp12};
  text-align: center;
`

export const WebsiteLink = styled(Link)`
  font-family: ${props => props.theme.texts.bodyMBold.fontFamily};
  font-size: ${props => props.theme.texts.bodyMBold.fontSize};
  font-weight: ${props => props.theme.texts.bodyMBold.fontWeight};
  line-height: ${props => props.theme.texts.bodyMBold.lineHeight};
  color: ${props => props.theme.colors.text.default};

  &:visited,
  &:hover {
    color: ${props => props.theme.colors.text.default};
  }
`
